import React, { Component } from 'react'
import { useParams, NavLink, Navigate } from 'react-router'
import './Edit.css'
import BackIcon from '../Icons/Back.svg'
import API from '../API'

class Edit extends Component {
	constructor(props) {
		super(props)
		this.Hostname = this.props.params.Hostname
		this.state = {}
		setTimeout(()=>this.Load(),0)
	}
	async Load() {
		if (this.Hostname == "_") {
			this.setState({Hostname: "", Data: {Target: ""}})
		} else {
			API('Web/Get', this.Hostname).then(Data=>{
				this.setState({Hostname: this.Hostname, Data: Data,Target:""})
				this.setState(Data)
			})
		}
		API('Projects/List').then(Projects=>this.setState({Projects:Projects}))
	}
	onSubmit(event) {
		event.preventDefault()
		event.stopPropagation()
		this.setState({Submitting: true})
		const Properties = {
			Target: event.currentTarget.elements.Target.value||event.currentTarget.elements.TargetText.value,
			Port443: parseInt(event.currentTarget.elements.Port443.value),
			Proto443: event.currentTarget.elements.Proto443.value,
			Port8443: parseInt(event.currentTarget.elements.Port8443.value||0),
			Proto8443: event.currentTarget.elements.Proto8443.value,
		}
		const Hostname = this.state.Hostname || (this.state.Target ? (this.state.Target+"."+window.App.state.Info?.ServerHost) : "")
		API('Web/Save', Hostname, Properties).then(Result=>{
			this.setState({Submitting: false})
			if (Result === true)
				this.setState({Redirect: <Navigate to="/ui/web" replace={true} />})
		})
	}
	Delete(event) {
		event.preventDefault()
		event.stopPropagation()
		if (window.confirm("Delete Web Forward "+this.Hostname+"?")) {
			this.setState({Submitting: true})
			API('Web/Delete', this.Hostname).catch(()=>{}).then((Result)=>{
				if (Result)
					this.setState({Redirect: <Navigate to="/ui/web" replace={true} />})
			})
		}
	}
	render() {
		const TargetValue=this.state.Target||undefined
		const TargetString=!(TargetValue&&this.state.Projects?.find(P=>P.Name==TargetValue))
		console.log("TargetValue", TargetValue, TargetString)
		const Hostname = this.state.Hostname || (this.state.Target ? (this.state.Target+"."+window.App.state.Info?.ServerHost) : "")
		console.log("this.state.Data", this.state.Data)
		return this.state.Data?(
			<div className="EditWeb">
				<h1><NavLink to="/ui/web"><img className="Icon" src={BackIcon} /></NavLink>&nbsp; Web Forward</h1>
				<form onSubmit={this.onSubmit.bind(this)}>
					<field>
						<label>Hostname</label>
						<input id="Name" disabled={this.Hostname!="_"} className={this.state.Hostname==this.Hostname?"":'Changed'} value={Hostname} onInput={(e)=>this.setState({Hostname:e.target.value.replace(/[^A-Za-z0-9_\.\-]/g, '').replace(/^[^A-Za-z0-9]*/, '').replace(/\.\./g, '.')})} />
					</field>
					<field>
						<label>Target Project</label>
						<select id="Target" value={TargetString?"":TargetValue} onChange={(e)=>this.setState({Target:e.target.value||""})}  className={(this.state.Target==this.state.Data.Target?"":"Changed")+" Right Grow"} style={TargetString?{maxWidth:"35px"}:{}}>
							<option value=""></option>
							{this.state.Projects?.map(P=><option value={P.Name}>{P.Name} - {P.Description}</option>)}
						</select>
						<input id="TargetText" value={TargetValue} onChange={(e)=>this.setState({Target:e.target.value})} style={TargetString?{display:"inline-block"}:{display:"none"}} className="Right Grow" />
					</field>
					<field>
						<label>HTTPS Port (https://{Hostname})</label>
						<div className="Row Grow">
							<div>
								<select id="Proto443" style={{width: '8em'}} className={this.state.Proto443==this.state.Data?.Proto443?"":'Changed'} value={this.state.Proto443 || this.state.Data?.Proto443 || 'http'} onInput={(e)=>this.setState({Proto443:e.target.value})}>
								<option value="http">http://</option>
									<option value="https">https://</option>
								</select>
							</div>
							<input id="Port443" type="number" className={this.state.Port443==this.state.Data?.Port443?"":'Changed'} value={this.state.Port443} onInput={(e)=>this.setState({Port443:e.target.value})} />
						</div>
					</field>
					<field>
						<label>Alternate HTTP Port (https://{Hostname}:8443)</label>
						<div className="Row Grow">
							<div>
								<select id="Proto8443" style={{width: '8em'}} className={this.state.Proto8443==this.state.Data?.Proto8443?"":'Changed'} value={this.state.Proto8443 || this.state.Data?.Proto8443 || 'http'} onInput={(e)=>this.setState({Proto8443:e.target.value})}>
									<option value="http">http://</option>
									<option value="https">https://</option>
								</select>
							</div>
							<input id="Port8443" type="number" className={this.state.Port8443==this.state.Data?.Port8443?"":'Changed'} value={this.state.Port8443} onInput={(e)=>this.setState({Port8443:e.target.value})} />
						</div>
					</field>
					<div className="Row Footer">
						<button class="Outline" style={{display:this.Hostname!="_"?'inline-block':'none'}} onClick={this.Delete.bind(this)}>Delete</button>
						<button class="Right" disabled={this.state.Submitting} type="submit">Save</button>
					</div>
				</form>
				{this.state.Redirect}
			</div>
		):(<div className="EditWeb Loading">Loading...</div>)
	}
}
function withRouter(Component) {
	return props => <Component params={useParams()} />;
}
export default withRouter(Edit)
